import {Component, EventEmitter, Input, Output, QueryList, ViewChildren} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbdSortableHeaderDirective} from '../../../directives/sortable.directive';
import {TableHeader} from '../../classes/TableHeader';
import {TableSort} from '../../classes/TableSort';

/**
 * This component displays a table with headers, who can be sortable or not. The contents of a table are described in a child component.
 */
@Component({
  selector: 'app-sortable-table',
  templateUrl: './sortable-table.component.html',
  styleUrls: ['./sortable-table.component.less'],
  imports: [CommonModule, NgbdSortableHeaderDirective]
})
export class SortableTableComponent {

  /** A list of all this directive elements in HTML. */
  @ViewChildren(NgbdSortableHeaderDirective) ngbdHeaders: QueryList<NgbdSortableHeaderDirective>;
  /** Header list of a table. */
  @Input() headers: TableHeader[];
  /** An event to sort the table. */
  @Output() sort = new EventEmitter<TableSort>();

  /**
   * Resets all table sort events and sorts by only one table column in the given direction.
   * @param tableSort a column and direction, in which the table should be sorted.
   */
  onSort(tableSort: TableSort): void {
    NgbdSortableHeaderDirective.prototype.reset(tableSort, this.ngbdHeaders);
    this.sort.emit(tableSort);
  }

}
